import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHelpOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.3335 7.99992C1.3335 4.31992 4.32016 1.33325 8.00016 1.33325C11.6802 1.33325 14.6668 4.31992 14.6668 7.99992C14.6668 11.6799 11.6802 14.6666 8.00016 14.6666C4.32016 14.6666 1.3335 11.6799 1.3335 7.99992ZM8.66683 10.6666V11.9999H7.3335V10.6666H8.66683ZM8.00016 13.3333C5.06016 13.3333 2.66683 10.9399 2.66683 7.99992C2.66683 5.05992 5.06016 2.66659 8.00016 2.66659C10.9402 2.66659 13.3335 5.05992 13.3335 7.99992C13.3335 10.9399 10.9402 13.3333 8.00016 13.3333ZM5.3335 6.66658C5.3335 5.19325 6.52683 3.99992 8.00016 3.99992C9.4735 3.99992 10.6668 5.19325 10.6668 6.66658C10.6668 7.52186 10.1401 7.98213 9.62734 8.43028C9.14084 8.85543 8.66683 9.26967 8.66683 9.99992H7.3335C7.3335 8.78574 7.96158 8.30431 8.51379 7.88103C8.94699 7.54899 9.3335 7.25273 9.3335 6.66658C9.3335 5.93325 8.7335 5.33325 8.00016 5.33325C7.26683 5.33325 6.66683 5.93325 6.66683 6.66658H5.3335Z",
		fill: "#0071CD"
	})
});
export default SvgHelpOutline;
